export default __webpack_public_path__ + "static/1-b043e22d8a236ff8a0106ac890ad5d2e.jpg";